import axios from 'axios';
import { mockRestaurant, mockResolvers } from './mockData';

// Use runtime config if available, otherwise fall back to build-time env
const getEnv = (key, defaultValue) => {
    if (window._env_ && window._env_[key]) {
        return window._env_[key];
    }
    return process.env[key] || defaultValue;
};

const API_BASE_URL = getEnv('REACT_APP_API_BASE_URL', 'http://localhost:5000');
// USE_MOCK determines if we force mock for EVERYTHING (e.g. local dev without any API)
const FORCE_MOCK = getEnv('REACT_APP_USE_MOCK', 'false') === 'true';

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

const isPreviewShortcode = (shortcode) => {
    return Object.prototype.hasOwnProperty.call(mockResolvers, shortcode);
};

export const resolveQRUrl = async (shortcode) => {
    if (FORCE_MOCK || isPreviewShortcode(shortcode)) {
        const { getMockResolve } = require('./mockData');
        return new Promise(resolve => setTimeout(() => resolve(getMockResolve(shortcode)), 500));
    }
    try {
        const response = await apiClient.get(`/api/v1/qr/qr-template-resolve/${shortcode}`);
        return response.data;
    } catch (error) {
        console.error('Error resolving QR template:', error);
        throw error;
    }
};

export const getRestaurantMenu = async (shortcode) => {
    if (FORCE_MOCK || isPreviewShortcode(shortcode)) {
        return new Promise(resolve => setTimeout(() => resolve(mockRestaurant), 800));
    }
    try {
        const response = await apiClient.get(`/api/v1/qr/qr-display/${shortcode}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching restaurant menu:', error);
        throw error;
    }
};

export const getPrintData = async (menuId, shortcode) => {
    if (FORCE_MOCK || isPreviewShortcode(shortcode)) {
        const { getMockPrintData } = require('./mockData');
        return new Promise(resolve => setTimeout(() => resolve(getMockPrintData(shortcode)), 600));
    }
    try {
        const response = await apiClient.get(`/api/v1/menus/${menuId}/print-data/${shortcode}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching print data:', error);
        throw error;
    }
};

export default apiClient;
